import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGraduationCap, faCheck, faLayerGroup, faAngleRight, faCircle, faLocationDot, faClock, faArrowRightLong} from '@fortawesome/free-solid-svg-icons'
import FrontHeader from '../components/FrontHeader'
import DashboardBanner from '../components/DashboardBanner'
import CryptoJourney from '../components/CryptoJourney'
import FrontFooter from '../components/FrontFooter'
import { formatCurrency } from '../utils/currencyUtils';

function Home() {
  const [plans, setPlans] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/register.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchPlan: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setPlans(data.plans);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching signals!')
    })
  }, []);
  const [news, setNews] = useState([]);
  useEffect(() => {
    fetch(`/apixxx_market.txt`)
    .then((res) => res.json())
    .then((data) => {
      var newsList = data.articles.results;
      const updatedData = newsList.map((newss, index) => ({
        id: index + 1,
        image: newss.image,
        title: newss.title,
        source: newss.source.title,
        date: newss.date,
      }));
      console.log(updatedData)
      setNews(updatedData);
    })
    .catch((err) => console.error("Error loading news list:", err));
  }, []);
  
  return (
    <div>
      <div className='overflow-hidden position-relative'>
        <FrontHeader/>
        <div className="bgdHome">
          <div className='container' style={{position: 'relative', zIndex: 5}}>
            <div className="row">
              <div className="col-lg-6">
                <h1 className="mb-0 text-capitalize" style={{fontSize:'55px',lineHeight:'1',fontWeight:'900'}}>You Don’t Have A Revenue Problem.</h1>
                <h1 className="mb-0 text-capitalize d-md-none em1" style={{fontSize:'55px',lineHeight:'1',fontWeight:'900'}}>You have an Execution problem.</h1>
                <em className="mb-0 text-capitalize rainbowText">You have an</em>
                <br/>
                <em className="mb-0 text-capitalize rainbowText">Execution problem.</em>
                <p className="mb-0 mt-3 londDes" style={{fontSize:'20px',lineHeight:'1.2'}}>You’ve taken the courses. You’ve watched the webinars. You’ve bought the software. And you’re STILL not hitting your targets. That’s not a knowledge problem. That’s an implementation problem. What Our Solution Provides:</p>
                <div className="mb-3 mt-4 dashedLine" style={{width:'50%',borderTop:'1px dashed #bdbdbd'}}></div>
                <p className="mb-0 shortDes" style={{fontSize:'17px',lineHeight:'1.2'}}>Solutions We Provide:</p>
                <div className="row mt-2">
                  <div className="col-md-6 g-3">
                    <div className="dottedCard">
                      <p className="fw-bold mb-0 text-center">A Dedicated Revenue Consultant</p>
                    </div>
                  </div>
                  <div className="col-md-6 g-3">
                    <div className="dottedCard">
                      <p className="fw-bold mb-0 text-center">Weekly 1-On-1 Meetings</p>
                    </div>
                  </div>
                  <div className="col-md-6 g-3">
                    <div className="dottedCard">
                      <p className="fw-bold mb-0 text-center">Expert Office Hours Every Week</p>
                    </div>
                  </div>
                  <div className="col-md-6 g-3">
                    <div className="dottedCard">
                      <p className="fw-bold mb-0 text-center">Revenue Scale Planning</p>
                    </div>
                  </div>
                </div>
              </div>
              <img src={require('../images/6a0360b551bf95bcbb608b09.png')} alt='shield' className="CenterImage"/>
            </div>
            <div className="d-flex flex-column align-items-center mt-md-5 mt-3 pt-2">
                <Link to="/account" state={{ location: 'login' }} className="myBtn3">
                  Book your strategy session
                </Link>
                <p className="mb-0 text-center mt-2" style={{ fontSize: '13px', color:'lightgray' }}>
                    Limited spots available. Talk to our team today.
                </p>
            </div>
          </div>
          <Link to="/account" state={{ location: 'login' }} className="myBtn4">
            Book your strategy session
          </Link>
        </div>
      </div>
      <section style={{paddingBottom: '2rem', paddingTop: '2rem'}}>
        <DashboardBanner />
        <CryptoJourney/>
      </section>
      <section style={{paddingBottom: '0rem'}}>
        <div className="container">
          <div className="d-flex justify-content-center">
            <p className="mb-0 px-4 py-3" style={{borderBottom:'3px solid #d1242aff', fontSize:'17px', fontWeight:'500'}}>THE SOLUTION</p>
          </div>
          <h1 className="mt-4 text-uppercase text-center mb-0 h1Small" style={{fontWeight:'900',fontSize:'45px'}}><span style={{color:'#d1242aff'}}>OptiglobalCapital</span><br/> FRACTIONAL REVENUE CONSULTING</h1>
          <div className="d-flex justify-content-center">
            <img src={require('../images/69f4deef0cd613c4f19670df.png')} alt='shield' className="Img1 mt-4 pt-3" style={{marginBottom:'-90px'}}/>
          </div>
        </div>
      </section>
      <section style={{paddingBottom: '4rem',paddingTop: '8rem',backgroundColor:'#e6e6e6'}}>
        <div className="container">
          <p className="text-center mb-0 text-black" style={{fontSize:'22px',fontWeight:'500'}}>You get ONE person who owns your success. They know your numbers, your team, your bottlenecks. Every call picks up where the last one left off.</p>
          <div className="d-flex flex-column align-items-center mt-3 pt-2">
            <Link to="/account" state={{ location: 'login' }} className="myBtn3">
              Book your strategy session
            </Link>
            <p className="mb-0 text-center mt-2" style={{ fontSize: '13px', color:'gray' }}>
                Limited spots available. Talk to our team today.
            </p>
          </div>
        </div>
      </section>
      <section style={{paddingBottom: '4rem',paddingTop: '2rem',backgroundColor:'#ffffff'}}>
        <div className="container">
          <div className="d-flex justify-content-center">
            <p className="mb-0 px-4 py-3 text-black" style={{borderBottom:'3px solid #d1242aff', fontSize:'17px',fontWeight:'500'}}>01 - The IMPLEMENTATION System</p>
          </div>
          <h1 className="mt-5 text-uppercase text-center mb-0 text-black h1Small" style={{fontWeight:'900',fontSize:'45px'}}>The 144 Point Implementation System</h1>
          <div className="row mt-5">
            <div className="col-lg-6 g-4">
              <img src={require('../images/69f4e24523e63d676c89718f.png')} alt='shield' style={{width:'100%'}}/>
            </div>
            <div className="col-lg-6 g-4">
              <p className="mb-0 text-black" style={{fontSize:'19px',fontWeight:'600'}}>This is NOT a PDF you download and forget. It’s not a course. It’s a structured, sequential execution framework built from the operational IP of a company that went from $2 million to $700 million. Your consultant walks you through it step by step, customized to where you are right now.</p>
              <div className="row mt-2">
                <div className="col-md-4 col-12 g-2">
                  <div className="p-2 rounded-3 d-flex flex-column align-items-center h-100" style={{backgroundColor:'#e6e6e6'}}>
                    <h3 className="text-center mb-0" style={{color:'#d1242aff',fontWeight:'900',lineHeight:'1.2'}}>01</h3>
                    <h5 className="mb-2 text-black text-center text-capitalize" style={{textDecoration:'underline',fontSize:'18px',fontWeight:'900'}}>Crypto Day Trading</h5>
                    <p className="mb-2 text-black text-center" style={{fontWeight:'900',fontSize:'13px',lineHeight:'1.2'}}>Take advantage of the bull run and master the art of crypto trading in the Crypto Trading campus, where we empower you to navigate the markets with precision.</p>
                  </div>
                </div>
                <div className="col-md-4 col-12 g-2">
                  <div className="p-2 rounded-3 d-flex flex-column align-items-center h-100" style={{backgroundColor:'#e6e6e6'}}>
                    <h3 className="text-center mb-0" style={{color:'#d1242aff',fontWeight:'900',lineHeight:'1.2'}}>02</h3>
                    <h5 className="mb-2 text-black text-center text-capitalize" style={{textDecoration:'underline',fontSize:'18px',fontWeight:'900'}}>Stock Market</h5>
                    <p className="mb-2 text-black text-center" style={{fontWeight:'900',fontSize:'13px',lineHeight:'1.2'}}>Stocks are your soldiers, and every trade is a tactic. Master the art of stock trading with us, and you'll learn to turn strategy into profit.</p>
                  </div>
                </div>
                <div className="col-md-4 col-12 g-2">
                  <div className="p-2 rounded-3 d-flex flex-column align-items-center h-100" style={{backgroundColor:'#e6e6e6'}}>
                    <h3 className="text-center mb-0" style={{color:'#d1242aff',fontWeight:'900',lineHeight:'1.2'}}>03</h3>
                    <h5 className="mb-2 text-black text-center text-capitalize" style={{textDecoration:'underline',fontSize:'18px',fontWeight:'900'}}>Real Estate</h5>
                    <p className="mb-2 text-black text-center" style={{fontWeight:'900',fontSize:'13px',lineHeight:'1.2'}}>Build long-term wealth by investing in real estate. Generate rental income, benefit from property value appreciation, and diversify your portfolio with tangible assets that can help protect against inflation..</p>
                  </div>
                </div>
                <div className="col-md-4 col-12 g-2">
                  <div className="p-2 rounded-3 d-flex flex-column align-items-center h-100" style={{backgroundColor:'#e6e6e6'}}>
                    <h3 className="text-center mb-0" style={{color:'#d1242aff',fontWeight:'900',lineHeight:'1.2'}}>04</h3>
                    <h5 className="mb-2 text-black text-center text-capitalize" style={{textDecoration:'underline',fontSize:'18px',fontWeight:'900'}}>401(K) Or Retirement Account</h5>
                    <p className="mb-2 text-black text-center" style={{fontWeight:'900',fontSize:'13px',lineHeight:'1.2'}}>Grow your long‑term wealth by contributing to a 401(k) or retirement account. Take advantage of employer matches, tax-deferred growth, and automated investing to build a secure financial future for your retirement.</p>
                  </div>
                </div>
                <div className="col-md-4 col-12 g-2">
                  <div className="p-2 rounded-3 d-flex flex-column align-items-center h-100" style={{backgroundColor:'#e6e6e6'}}>
                    <h3 className="text-center mb-0" style={{color:'#d1242aff',fontWeight:'900',lineHeight:'1.2'}}>05</h3>
                    <h5 className="mb-2 text-black text-center text-capitalize" style={{textDecoration:'underline',fontSize:'18px',fontWeight:'900'}}>Sales Conversion</h5>
                    <p className="mb-2 text-black text-center" style={{fontWeight:'900',fontSize:'13px',lineHeight:'1.2'}}>We give your sales team a proven process that increases close rates across the board.</p>
                  </div>
                </div>
                <div className="col-md-4 col-12 g-2">
                  <div className="p-2 rounded-3 d-flex flex-column align-items-center h-100" style={{backgroundColor:'#e6e6e6'}}>
                    <h3 className="text-center mb-0" style={{color:'#d1242aff',fontWeight:'900',lineHeight:'1.2'}}>06</h3>
                    <h5 className="mb-2 text-black text-center text-capitalize" style={{textDecoration:'underline',fontSize:'18px',fontWeight:'900'}}>Training & Execution</h5>
                    <p className="mb-2 text-black text-center" style={{fontWeight:'900',fontSize:'13px',lineHeight:'1.2'}}>We install ongoing training with testing, certification, & management reporting. Companies that train consistently see 218% more revenue per employee.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p className="text-black text-center mt-5 pt-3 mb-0" style={{fontSize:'19px',fontWeight:'500'}}>Points are awarded for things done well. Points are deducted for critical mistakes. Every call gets a total score and grade so you can see with mathematical precision what's working and what needs to change.</p>
          <p className="text-black text-center mt-3 mb-0" style={{fontSize:'23px',fontWeight:'700'}}><span style={{color:'#d1242aff'}}>No guessing. No assumptions.</span> Just the cold, hard truth about how your team performs when you're not watching.</p>
          <div className="d-flex flex-column align-items-center mt-md-5 mt-3">
            <Link to="/account" state={{ location: 'login' }} className="myBtn3">
              Book your strategy session
            </Link>
            <p className="mb-0 text-center mt-2" style={{ fontSize: '13px', color:'gray' }}>
                Limited spots available. Talk to our team today.
            </p>
          </div>
        </div>
      </section>
      <section style={{paddingBottom: '4rem',paddingTop: '2rem'}}>
        <div className="container">
          <div className="d-flex justify-content-center">
            <p className="mb-0 px-4 py-3" style={{borderBottom:'3px solid #d1242aff', fontSize:'17px',fontWeight:'500'}}>02 - ACCESS TO EXPERTS</p>
          </div>
          <h1 className="mt-4 text-center mb-0 h1Small" style={{fontWeight:'900',fontSize:'48px'}}>Expert Office Hours</h1>
          <p className="mb-0 text-center mt-4" style={{fontSize:'19px',fontWeight:'500'}}>10 Sessions Per Week. 2x Daily. 5 Days.</p>
          <div className="row mt-4 align-items-center">
            <div className="col-lg-6 g-3">
              <p className="mb-4 text-center" style={{fontSize:'19px',fontWeight:'500'}}>When you hit a wall, you don’t Google it. You don’t watch a YouTube video. You get on a live call with someone who’s solved that exact problem hundreds of times and you get a working answer that day.</p>
              <div className="mb-2 rounded-4" style={{border:'1px solid #ffffff9c',backgroundColor:'#ffffff29',padding:'12px 24px'}}>
                <p className="mb-0 text-end" style={{fontWeight:'500',fontSize:'18px',lineHeight:'1'}}>World-class custom built learning application</p>
              </div>
              <div className="mb-2 rounded-4" style={{border:'1px solid #ffffff9c',backgroundColor:'#ffffff29',padding:'12px 24px'}}>
                <p className="mb-0 text-end" style={{fontWeight:'500',fontSize:'18px',lineHeight:'1'}}>Scale from Zero to $10k/month as fast as possible</p>
              </div>
              <div className="mb-2 rounded-4" style={{border:'1px solid #ffffff9c',backgroundColor:'#ffffff29',padding:'12px 24px'}}>
                <p className="mb-0 text-end" style={{fontWeight:'500',fontSize:'18px',lineHeight:'1'}}>Master skills you need to maximize your income</p>
              </div>
              <div className="mb-2 rounded-4" style={{border:'1px solid #ffffff9c',backgroundColor:'#ffffff29',padding:'12px 24px'}}>
                <p className="mb-0 text-end" style={{fontWeight:'500',fontSize:'18px',lineHeight:'1'}}>Celebrate your wins with people who understand</p>
              </div>
              <div className="mb-2 rounded-4" style={{border:'1px solid #ffffff9c',backgroundColor:'#ffffff29',padding:'12px 24px'}}>
                <p className="mb-0 text-end" style={{fontWeight:'500',fontSize:'18px',lineHeight:'1'}}>Make like-minded friends on your journey</p>
              </div>
              <div className="mb-2 rounded-4" style={{border:'1px solid #ffffff9c',backgroundColor:'#ffffff29',padding:'12px 24px'}}>
                <p className="mb-0 text-end" style={{fontWeight:'500',fontSize:'18px',lineHeight:'1'}}>Network with 113,000+ students</p>
              </div>
              <div className="mb-2 rounded-4" style={{border:'1px solid #ffffff9c',backgroundColor:'#ffffff29',padding:'12px 24px'}}>
                <p className="mb-0 text-end" style={{fontWeight:'500',fontSize:'18px',lineHeight:'1'}}>Mentors are hyper-successful experts in their field</p>
              </div>
              <div className="mb-2 rounded-4" style={{border:'1px solid #ffffff9c',backgroundColor:'#ffffff29',padding:'12px 24px'}}>
                <p className="mb-0 text-end" style={{fontWeight:'500',fontSize:'18px',lineHeight:'1'}}>Get mentored every step of your journey</p>
              </div>
              <div className="mb-2 rounded-4" style={{border:'1px solid #ffffff9c',backgroundColor:'#ffffff29',padding:'12px 24px'}}>
                <p className="mb-0 text-end" style={{fontWeight:'500',fontSize:'18px',lineHeight:'1'}}>1-on-1 advice from industry experts</p>
              </div>
            </div>
            <div className="col-lg-6 g-3">
              <img src={require('../images/69f4e6d70cd613c4f19823e8.png')} alt='shield' style={{width:'100%'}}/>
            </div>
          </div>
          <p className="text-center mt-5 mb-0" style={{fontSize:'19px',fontWeight:'500'}}>Instead of hiring a $100K media buyer, you get ours. <br/> Bring your campaigns, your metrics, your questions. Get answers that same day.</p>
          <div className="d-flex flex-column align-items-center mt-md-4 mt-3">
            <Link to="/account" state={{ location: 'login' }} className="myBtn3">
              Book your strategy session
            </Link>
            <p className="mb-0 text-center mt-2" style={{ fontSize: '14px', color:'lightgray' }}>
                Limited spots available. Talk to our team today.
            </p>
          </div>
        </div>
      </section>
      <section style={{paddingBottom: '4rem',paddingTop: '2rem',backgroundColor: '#ffffff'}}>
        <div className="container">
          <div className="d-flex justify-content-center">
            <p className="mb-0 px-4 py-3 text-black" style={{borderBottom:'3px solid #d1242aff', fontSize:'17px',fontWeight:'500'}}>03 - CARDONE UNIVERSITY</p>
          </div>
          <h1 className="mt-4 text-center mb-0 text-black h1Small" style={{fontWeight:'900',fontSize:'48px'}}>Interactive 24/7 Training Portal</h1>
          <div className="row mt-4">
            <div className="col-lg-6 g-3">
              <img src={require('../images/69f4e87c8831cb2c6c8785d3.png')} alt='shield' style={{width:'100%'}}/>
            </div>
            <div className="col-lg-6 g-3">
              <p className="text-black mb-3" style={{fontWeight:'500',fontSize:'19px'}}>On-demand video training available 24/7 covering all 6 revenue areas. Your entire team gets trained on the same frameworks, creating consistency and alignment across your organization.</p>
              <img src={require('../images/69f4e87ce9694b9664fb3e80.png')} alt='shield' style={{width:'100%'}}/>
              <p className="mb-0 text-black mt-3" style={{fontWeight:'700',fontSize:'19px'}}>You’ll know exactly who’s training, what they’ve completed, and how they scored. No guessing.</p>
            </div>
          </div>
          <div className="d-flex flex-column align-items-center mt-md-5 mt-3">
            <Link to="/account" state={{ location: 'login' }} className="myBtn3">
              Book your strategy session
            </Link>
            <p className="mb-0 text-center mt-2" style={{ fontSize: '14px', color:'gray' }}>
                Limited spots available. Talk to our team today.
            </p>
          </div>
        </div>
      </section>
      <section style={{paddingBottom: '4rem',paddingTop: '2rem'}}>
        <div className="container">
          <div className="d-flex justify-content-center">
            <p className="mb-0 px-4 py-3" style={{borderBottom:'3px solid #d1242aff', fontSize:'17px',fontWeight:'500'}}>04 - weekly 1 on 1 consulting</p>
          </div>
          <h1 className="mt-4 text-center mb-0 h1Small" style={{fontWeight:'900',fontSize:'48px'}}>How We Support You</h1>
          <p className="mb-0 text-center mt-4" style={{fontSize:'19px',fontWeight:'500'}}>Weekly Coaching & Implementation Sessions</p>
          <div className="row mt-4 align-items-center">
            <div className="col-lg-6 g-3">
              <p className="mb-0" style={{fontSize:'19px',fontWeight:'500'}}>Your consultant is available weekly. Office hours run twice a day, five days a week. You’re never more than a few hours away from expert-level support in any area of your revenue engine. <br/> Monday through Friday. Morning and afternoon sessions. Bring your questions, your screenshots, your broken funnels, leave with answers and a plan.</p>
              <p className="mb-0 mt-3 mb-0" style={{fontSize:'19px',fontWeight:'700'}}>To do this on your own:</p>
              <div className="mt-3 mb-1 d-flex align-items-center justify-content-between px-3">
                <p className="mb-0" style={{fontSize:'12px'}}>PLANS</p>
                <p className="mb-0" style={{fontSize:'12px'}}>INVESTMENT & ROI</p>
              </div>
              {plans.map((plan) => (
              <div className="mb-1 rounded-3 d-flex align-items-center justify-content-between" style={{border:'1px solid #ffffff9c',backgroundColor:'#ffffff29',padding:'5px 18px'}}>
                <p className="mb-0 text-end" style={{fontWeight:'600',fontSize:'18px',lineHeight:'1'}}>{plan.subscribe_name} Plan</p>
                <p className="mb-0 text-end" style={{fontWeight:'600',fontSize:'18px',lineHeight:'1'}}>${formatCurrency(plan.amount)} - {plan.percentage}%</p>
              </div>
              ))}
            </div>
            <div className="col-lg-6 g-3">
              <div className="w-100 rounded-4 d-flex align-items-center justify-content-center overflow-hidden">
                <img src={require('../images/69f4eaa80cd613c4f198ef33.png')} alt='shield' style={{width:'100%',height:'100%',objectFit:'cover'}}/>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section style={{paddingBottom: '4rem',paddingTop: '2rem',backgroundColor:'#e6e6e6'}}>
        <div className="container">
          <div className="d-flex justify-content-center">
            <p className="mb-0 px-4 py-3 text-black" style={{borderBottom:'3px solid #d1242aff', fontSize:'17px',fontWeight:'500'}}>ABOUT US</p>
          </div>
          <h1 className="mt-4 mb-0 text-capitalize text-center text-black h1Small" style={{fontSize:'47px',lineHeight:'1.2',fontWeight:'900'}}>This isn’t Our First Business.</h1>
          <h1 className="mb-0 text-capitalize text-center em1 h1Small" style={{fontSize:'47px',lineHeight:'1',fontWeight:'900'}}>It’s Our 4th $100M+ Business.</h1>
          <div className="row mt-4" style={{marginBottom:'-40px'}}>
            <div className="col-lg-6">
              <div className="bgd1 d-flex justify-content-end align-items-center h-100">
                <img src={require('../images/69f4f149daa24d9895088097.png')} alt='shield' style={{maxWidth:'400px',width:'100%'}}/>
              </div>
            </div>
            <div className="col-lg-6">
              <img src={require('../images/69f4f14923e63d676c8c9b1d.png')} alt='shield' style={{width:'100%'}}/>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 g-4">
              <div className="bg-white px-3 rounded-4 d-flex flex-column align-items-cenetr" style={{paddingTop:'2rem',paddingBottom:'2rem'}}>
                <h1 className="text-center mb-0" style={{fontSize:'70px',fontWeight:'900',color:'#d1242aff'}}>$700M</h1>
                <p className="text-center mb-0 text-black" style={{fontSize:'17px',fontWeight:'600'}}>TOTAL COMPANY REVENUE</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 g-4">
              <div className="bg-white px-3 rounded-4 d-flex flex-column align-items-cenetr" style={{paddingTop:'2rem',paddingBottom:'2rem'}}>
                <h1 className="text-center mb-0" style={{fontSize:'70px',fontWeight:'900',color:'#d1242aff'}}>268</h1>
                <p className="text-center mb-0 text-black" style={{fontSize:'17px',fontWeight:'600'}}>EMPLOYEES</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 g-4">
              <div className="bg-white px-3 rounded-4 d-flex flex-column align-items-cenetr" style={{paddingTop:'2rem',paddingBottom:'2rem'}}>
                <h1 className="text-center mb-0" style={{fontSize:'70px',fontWeight:'900',color:'#d1242aff'}}>60+</h1>
                <p className="text-center mb-0 text-black" style={{fontSize:'17px',fontWeight:'600'}}>CONSULTANTS & COACHES</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 g-4">
              <div className="bg-white px-3 rounded-4 d-flex flex-column align-items-cenetr" style={{paddingTop:'2rem',paddingBottom:'2rem'}}>
                <h1 className="text-center mb-0" style={{fontSize:'70px',fontWeight:'900',color:'#d1242aff'}}>35 YRS</h1>
                <p className="text-center mb-0 text-black" style={{fontSize:'17px',fontWeight:'600'}}>PROVEN EXPERIENCE</p>
              </div>
            </div>
          </div>
          <p className="text-center mt-5 mb-0 text-black" style={{fontSize:'21px',fontWeight:'500',lineHeight:'1.3'}}>We didn’t read about this in a book. We built a $700+ million company and now <br/> we’re giving you access to the same systems and people that did it.</p>
          <div className="d-flex flex-column align-items-center mt-md-4 mt-3 pt-2">
            <Link to="/account" state={{ location: 'login' }} className="myBtn3">
              Book your strategy session
            </Link>
            <p className="mb-0 text-center mt-2" style={{ fontSize: '14px', color:'gray' }}>
                See exactly where you’re leaving money on the table. 20 minutes. No obligation.
            </p>
          </div>
        </div>
      </section>
      <section style={{paddingBottom: '4rem', paddingTop: '4rem',backgroundColor: '#f8f8ff'}}>
        <div className="container">
          <div id='events'>
            <h1 className='text-black text-center display-5 mb-4' style={{fontWeight:'900'}}>Join Events for meet us</h1>
            <div className='row'>
              {news.slice(0, 4).reverse().map((newItem) => (
              <div key={newItem.id} className='col-lg-3 col-md-6 col-12 g-4'>
                <div className='blog-card'>
                  <div className='blogImg mb-3'>
                    <img src={newItem.image} alt='profile'/>
                  </div>
                  <h6 className='text-black fw-semibold'>{newItem.title.split(' ').length <= 10
                                ? newItem.title
                                : `${newItem.title.split(' ').slice(0, 10).join(' ')}...`}</h6>
                  <p className='text-black mb-2'><FontAwesomeIcon icon={faLocationDot} className='fs-7 text-primary fw-bold me-2' /> {newItem.source}</p>
                  <p className='text-black mb-0'><FontAwesomeIcon icon={faClock} className='fs-7 text-primary fw-bold me-2' /> {newItem.date}</p>
                  <Link to="/account" state={{location: 'login'}} className='btn mybtn px-5 fs-7 mt-4 fw-semibold' style={{paddingTop: '12px',paddingBottom: '12px'}}>JOIN US</Link>
                </div>
              </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section style={{paddingBottom: '4rem', paddingTop: '2rem'}}>
        <div className="container">
          <div className="d-flex justify-content-center">
            <p className="mb-0 px-4 py-3" style={{borderBottom:'3px solid #d1242aff', fontSize:'17px',fontWeight:'500'}}>FAQ</p>
          </div>
          <h1 className="mt-4 text-center mb-0 h1Small" style={{fontWeight:'900',fontSize:'48px'}}>You Have Questions. <br/> We Have Answers.</h1>
          <div className="accordion mt-5" id="faqAccordion">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faq1"
                >
                  I’ve tried coaching before and it didn’t work.
                </button>
              </h2>
              <div
                id="faq1"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Good. That means you know what doesn’t work. This isn’t coaching. When you hit a technical wall, your tracking is broken, your automations don’t fire, your ads aren’t converting, you bring it to a subject matter expert who’s solved that exact problem dozens of times and get a working answer that week. Not motivation. Execution support.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faq2"
                >
                  I don’t have time for another program.
                </button>
              </h2>
              <div
                id="faq2"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  This REPLACES the 40 hours a week you spend trying to figure out media buying, CRM setup, automation, and AI on your own. Your consultant does the thinking. You do the executing. Net result: you get time back.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faq3"
                >
                  How expensive is it?
                </button>
              </h2>
              <div
                id="faq3"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Because of our size and scale, we are able to help you in all of the core areas of revenue operations in your business for a fraction of the cost. You can’t hire a receptionist in your business for what we offer and the price point we offer it at. One improvement to your conversion rate, your ad efficiency, your sales process, or your follow-up system pays for the ENTIRE YEAR.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faq4"
                >
                  Can’t AI just do all of this?
                </button>
              </h2>
              <div
                id="faq4"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  AI gives you information. So does Google. The problem has NEVER been access to information. It’s implementation. Has AI tripled your business yet? Has it 4X’d your net income? Tools without systems don’t produce results. We help build the systems.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faq5"
                >
                  I need to think about it.
                </button>
              </h2>
              <div
                id="faq5"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Of course. While you’re thinking, your competitors are implementing. Three options: do nothing and nothing changes, try to do it yourself and spend two years and a million dollars, or do it with us and start getting results this week. Which one makes the most sense?
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column align-items-center mt-md-4 mt-3 pt-2">
            <Link to="/account" state={{ location: 'login' }} className="myBtn3">
              Book your strategy session
            </Link>
            <p className="mb-0 text-center mt-2" style={{ fontSize: '14px', color:'lightgray' }}>
                Get the same systems that built a nine-figure company working for yours.
            </p>
          </div>
        </div>
      </section>
      <FrontFooter/>
    </div>
  )
}

export default Home